import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { windowResize } from '../../redux/reducers/resizeSlice'
import SubFilter from '../../components/subFilter/SubFilter'
import SearchResultGrid from '../../sections/searchResultGrid/SearchResultGrid'
import ShowMoreSection from '../../sections/showMoreSection/ShowMoreSection'
import { instructorSearchConnector } from '../../server/connector/InstructorSearchConnector';
import { searchDataUpdated } from '../../redux/reducers/searchSlice'
import Footer from '../../sections/footer/Footer'
import HeaderSearch from '../../sections/header/HeaderSearch'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'

function Home() {
	const searchRequestInProgress: boolean = useAppSelector((state) => state.search.searchRequestInProgress)
	const [firstSearchLoaded, setFirstSearchLoaded] = useState<boolean>(false)

	const dispatch = useAppDispatch()

	useEffect(() => {
		initializeSite()
	})

	// Called on initial page load and used to prepare the site
	const initializeSite = () => {
		addResizeHandler()
		makeInitialSearchRequest()
	}

	const addResizeHandler = () => {
		window.addEventListener('resize', () => {
			dispatch(windowResize())
		})
		dispatch(windowResize())
	}

	const makeInitialSearchRequest = () => {
		instructorSearchConnector.performSearchRequest().then((successRequest) => {
			setFirstSearchLoaded(true)
			dispatch(searchDataUpdated())
			if (!successRequest) {
				console.log('WARNING - [App] - performSearchRequest() failed')
			}
		})
	}

	return (
		<>
			{firstSearchLoaded &&
				<>
					<div className='section-wrap section-seperator'>
						<div className='section-content'>
							<HeaderSearch />
						</div>
					</div>
					<div className='section-wrap section-seperator lcp-shift-min-height'>
						<SubFilter />
						<SearchResultGrid />
						{searchRequestInProgress && (
							<div>Loading</div>
						)}
						<ShowMoreSection />
					</div>
					<div className='section-wrap section-seperator'>
						<div className='section-content'>
							<Footer />
						</div>
					</div>
					<BackToTopButton />
				</>
			}
		</>
	)
}

export default Home
